import script from "./PastAchievements.vue?vue&type=script&setup=true&lang=ts"
export * from "./PastAchievements.vue?vue&type=script&setup=true&lang=ts"

import "./PastAchievements.vue?vue&type=style&index=0&id=23341c70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23341c70"]])

export default __exports__